<template>
  <div v-if='tx != null'>
    <h1 class="pageHeader">
      <span class="pageHeader__title">Transaction Details</span>
    </h1>

    <div id="txVisual" class="blockBorder">
      <div class='txdiv'>
        <table class='table table--awd'>
          <tbody>
            <tr class="table__header hidden-xs-down">
              <td class='table__cell table__cell--lowercase' colspan='3'>
                <router-link :to="{ path: '/tx/' + tx.txid }" class="link link--gray">
                  {{ tx.txid }}
                </router-link>
                <span class="table__txRight txt-white"></span>
              </td>
            </tr>
            <tr class="table__header hidden-sm-up">
              <td class="table__cell table__cell--lowercase">
                <router-link :to="{ path: '/tx/' + tx.txid }" class="link link--gray">
                  {{ tx.txid }}
                </router-link>
                <span class="table__txRight txt-white"></span>
              </td>
            </tr>
            <tr class="table__row table__row--trasparent">
              <td class="table__cell table__cell--input txt-white">
                <template v-if="!tx.inputs.length">
                  Coinbase (newly generated coins)
                </template>
                <template v-else-if="tx.additional && tx.additional.minting">
                  <template v-for='input in tx.additional.minting.inputs'>
                    <router-link :to="{ path: '/address/' + input.address }"
                                 :key='input.parent'
                                 class="link">
                      <template v-if="input.address == moneybox">
                        PLC Minting Depot
                      </template>
                      <template v-else>
                        {{ input.address }}
                        <span :key='input.parent'>
                          <span class="table__txRight table__txRight--sm-left txt-white">
                            {{ input.value | formatPlc }}

                            ({{ [ input.delta, 'seconds' ] | duration('format', 'd[d] hh[h] mm[m]') }})
                          </span>
                        </span>
                      </template>
                      <br/>
                    </router-link>
                  </template>
                </template>
                <template v-else>
                  <router-link v-for='input in tx.inputs'
                               :key='input'
                               :to="{ path: '/address/' + input }"
                               class="link">
                    {{ input }}
                    <br/>
                  </router-link>
                </template>
              </td>
              <v-iarrow :tx="tx"></v-iarrow>
              <td class="table__cell table__cell--output">
                <template v-for="(output, index) in tx.outputs">
                  <router-link :key="index + 'link'"
                               :to="{ path: '/address/' + output.address }"
                               class="link">
                    <template v-if="output.address == moneybox">
                      PLC Minting Depot
                    </template>
                    <template v-else>
                      {{ output.address }}
                    </template>
                  </router-link>
                  <span :key="index + 'plc'">
                    <span class="table__txRight table__txRight--sm-left txt-white">
                      {{ output.value | formatPlc }}
                      <router-link v-if="output.usedBy"
                                   :key="index + 'link'"
                                   :to="{ path: '/tx/' + output.usedBy[0] }">
                        ➡️
                      </router-link>
                    </span>
                    <br/>
                  </span>
                </template>
              </td>
            </tr>
          </tbody>
        </table>

        <div class="confirmation confirmation--sm-center confirmation--mb-0">
          <template v-if="tx.confirmations < 120">
            <button v-if="tx.confirmations > 0" class="confirmation__button confirmation__button--normal"> {{ tx.confirmations }} Confirmations</button>
            <button v-else class='confirmation__button confirmation__button--negative'>Unconfirmed Transaction!</button>
          </template>
        </div>

      </div>
    </div>

    <div class="row">
      <div class="col-md-6 mb-5">
        <table class="table" id="txSummary">
          <tbody>
            <tr class="table__header">
              <td class="table__title table__title--low" colspan="2">Summary</td>
            </tr>
            <tr class="table__row">
              <td class="table__cell txt-gray">Size</td>
              <td class="table__cell txt-white">{{ tx.size }}</td>
            </tr>
            <tr class="table__row">
              <td class="table__cell txt-gray">Received</td>
              <td class="table__cell txt-white"><timeago :since="tx.time * 1000" :auto-update="60"></timeago></td>
            </tr>
            <tr class="table__row">
              <td class="table__cell txt-gray">Date and Time</td>
              <td class="table__cell txt-white">{{ tx.time | setDateAndTime }}</td>
            </tr>
            <tr v-if="tx.confirmations > 0" class="table__row">
              <td class="table__cell txt-gray">Included in Block</td>
              <td class="table__cell txt-white">
                <router-link :to="{ path: '/block/' + tx.blockNumber }"
                             class="link">
                  {{ tx.blockNumber }}
                </router-link>
              </td>
            </tr>
            <tr class="table__row">
              <td class="table__cell txt-gray">Confirmations</td>
              <td class="table__cell txt-white">{{ tx.confirmations }} Confirmations</td>
            </tr>
            <tr class="table__row">
              <td class="table__cell txt-gray">Type</td>
              <td class="table__cell txt-white">{{ tx.type | capitalize }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col-md-6">
        <table class="table" id="txInOut">
          <tbody>
            <tr class="table__header">
              <td class="table__title table__title--low" colspan="2">Inputs and Outputs</td>
            </tr>
            <tr class="table__row">
              <td class="table__cell txt-gray">Total Input</td>
              <td class="table__cell txt-white">{{ tx.inputsValue | formatPlc }}</td>
            </tr>
            <tr class="table__row">
              <td class="table__cell txt-gray">Total Output</td>
              <td class="table__cell txt-white">{{ tx.outputsValue | formatPlc }}</td>
            </tr>
            <tr class="table__row">
              <td class="table__cell txt-gray">Fees</td>
              <td class="table__cell txt-white">{{ getter_fees | formatPlc }}</td>
            </tr>
            <template v-if="tx.additional && tx.additional.minting">
              <tr class="table__row">
                <td class="table__cell txt-gray">Included Own Fee</td>
                <td class="table__cell txt-white">{{ tx.additional.minting.userFee | formatPlc }}</td>
              </tr>
              <tr class="table__row">
                <td class="table__cell txt-gray">Minted Amount</td>
                <td class="table__cell txt-white">{{ tx.additional.minting.input | formatPlc }}</td>
              </tr>
              <tr class="table__row">
                <td class="table__cell txt-minted">New Born Amount</td>
                <td class="table__cell txt-minted">{{ tx.additional.minting.minted | formatPlc }}</td>
              </tr>
            </template>
            <template v-else>
            </template>
            <template v-if="tx.additional && tx.additional.minting">
            </template>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from '../service/ApiService'

export default {
  name: 'Transaction',

  data: () => ({
    getter_fees: 0,
    tx: null,
    moneybox: ''
  }),

  watch: {
    '$route': 'fetchTx'
  },

  created () {
    this.fetchTx()
  },

  methods: {
    async fetchTx () {
      try {
        const info = await ApiService.getInfo()
        if (!info) {
          throw Error('Failed to load information')
        }
        this.moneybox = info.moneybox
        const response = await ApiService.searchById(this.$route.params.id)
        if (!response) {
          this.$router.push({ path: '/not-found' })
          return
        }
        this.tx = response.result
        this.setFees()
      } catch (error) {
        let obj = {
          title: 'Oops!',
          message: 'Internal error. Please let us know.',
          type: 'error'
        }
        this.$root.$children[0].$refs.simplert.opensimplert(obj)
      }
    },

    setFees () {
      this.getter_fees = this.tx.inputs.length === 0 ? 0 : this.tx.inputsValue - this.tx.outputsValue
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Transaction.vue